<template>
  <section class="sme-container__info">
    <sme-quick-info
      :form-data="formData"
      :smeClassId="formData.class_id"></sme-quick-info>
    <div class="box">
      <div class="table mg-b-10 table_no_title">
        <div class="tr">
          <span class="fw-600">Insured Period</span>
          <span
            v-copy="policy_detail.ins_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ policy_detail.ins_period}}</span>
        </div>
        <div class="tr">
          <span class="fw-600">Expected Insured Period</span>
          <span
            v-copy="policy_detail.pcy_cmnt_expry_dt_nm"
            :class="{'green-tip':handleCompare('period_date')}">{{ policy_detail.pcy_cmnt_expry_dt_nm }}</span>
        </div>
        <div class="tr">
          <span class="fw-600">Total Price</span>
          <span
            v-copy="policy_detail.amount"
            :class="{'green-tip':isChange}">{{ policy_detail.amount }}</span>
        </div>
        <div
          v-if="!isEndorse"
          class="tr">
          <span class="fw-600">Policy Number </span>
          <span
            v-copy="policy_detail.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ policy_detail.pcy_no  }}</span>
        </div>
        <div
          v-else
          class="tr">
          <span class="fw-600">Endorsement Number </span>
          <span
            v-copy="policy_detail.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ policy_detail.endorser_no  }}</span>
        </div>
        <div class="tr">
          <span class="fw-600">Policy Reference Code </span>
          <span
            v-copy="policy_detail.pcy_ref_no"
            :class="{'green-tip':handleCompare('pcy_ref_no')}">{{ policy_detail.pcy_ref_no }}</span>
        </div>
      </div>
    </div>
    <div class="box">
      <div
        v-if="coverageList"
      >
        <div

          class="table">
          <div
            class=" th font-14">
            Coverage
          </div>
          <template v-if="coverageList.contents.length>0">
            <section
              v-for="(coverage_item,index) in coverageList.contents"
              :key="'coverage_item'+index"
              class="table_tr_border0">
              <div
                class="tr tr-gray__title">
                <span class="fw-600 ">{{coverage_item.title}}</span>
              </div>
              <section
                v-for="(content_item,index) in coverage_item.items"
                :key="'content_item'+index">
                <div
                  class="tr">
                  <span class="fw-600">{{content_item.item}}</span>
                  <span v-copy="content_item.premium_str">{{content_item.premium_str}}</span>
                </div>
              </section>
            </section>
          </template>
          <div class="tr">
            <span class="fw-600 top-algin">Coverage Remark</span>
            <span
              v-copy="changeLineData(coverageList.remarks)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(coverageList.remarks)"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div
        v-if="excessList"
      >
        <div

          class="table">
          <div
            class=" th font-14">
            Excess
          </div>
          <template v-if="excessList.contents.length>0">
            <section
              v-for="(excess_item,index) in excessList.contents"
              :key="'excess_item'+index"
              class="table_tr_border0"
            >
              <div
                class="tr tr-gray__title">
                <span
                  v-copy="excess_item.title"
                  class="fw-600">{{excess_item.title}}</span>
              </div>
              <section
                v-for="(excess_content_item,index) in excess_item.items"
                :key="'excess_content_item'+index">
                <div
                  class="tr">
                  <span class="fw-600">{{excess_content_item.item}}</span>
                  <span v-copy="excess_content_item.premium_str">{{excess_content_item.premium_str}}</span>
                </div>
              </section>
            </section>
          </template>
          <div class="tr">
            <span class="fw-600 top-algin">Excess Remark</span>
            <span
              v-copy="changeLineData(excessList.remarks)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(excessList.remarks)"></span>
          </div>
        </div>
      </div>
    </div>
    <sme-kyc-info
      :form-data="formData"
      :class-id="formData.class_id"></sme-kyc-info>

    <div class="box">
      <div class="table">
        <div class="th font-14">Remark(s)</div>
        <div class="tr">
          <span class="fw-600 top-algin">Remark</span>
          <span
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import smeKycInfo from '@/views/quoting/sme/component/smeKycInfo'
import smeQuickInfo from '@/views/quoting/sme/component/smeQucikInfo'

export default {
  name: 'smePolicyDetailInfo',
  components:{
    smeKycInfo,
    smeQuickInfo
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    policy_detail(){
      let {policy_detail} = this.formData||{}
      return policy_detail||{}
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },

    coverageList(){
      let {sidebar_info} = this.formData||{}
      let {coverage={}} = sidebar_info||{}
      return  coverage
    },
    excessList(){
      let {sidebar_info} = this.formData||{}
      let {excess={}} = sidebar_info||{}
      return  excess
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  methods: {
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    getName(id){
      let data = this.coverageOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    },
    remark(name){
      let data = this.formData[name]||''
      return data?data.replace(/\n/g, '<br/>'):'-'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../quoting/sme/info";
.housemaid-quote-info{
  //.box {
  //  margin-bottom: 15px;
  //}
  //.title {
  //  display: block;
  //  padding-bottom: 15px;
  //  font-size: 16px;
  //  font-weight: 400;
  //  color: #616266;
  //}
  //.table-title {
  //  display: inline-block;
  //  padding-bottom: 2px;
  //  padding-left: 5px;
  //  font-size: 12px;
  //  font-weight: bold;
  //  color: #909399;
  //  line-height: 15px;
  //}
  .green-tip{
    color: #0E9A00!important;
  }
}
</style>
